var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTerminal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2343_6943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4397 7.75H18.7845V4.36207C18.7845 3.88793 18.3965 3.5 17.9224 3.5H1.86207C1.38793 3.5 1 3.88793 1 4.36207V21.6379C1 22.1121 1.38793 22.5 1.86207 22.5C2.0431 22.5 2.19828 22.431 2.32759 22.3448C2.46552 22.4397 2.62069 22.5 2.7931 22.5H9.01724C9.49138 22.5 9.87931 22.1121 9.87931 21.6379V18.5259C9.87931 18.0517 9.49138 17.6638 9.01724 17.6638H8.32759V15.4138C8.32759 14.9397 7.93965 14.5517 7.46552 14.5517H4.35345C3.87931 14.5517 3.49138 14.9397 3.49138 15.4138V17.6638H2.80172C2.80172 17.6638 2.75 17.681 2.72414 17.681V5.22414H17.0517V7.74138H12.1724C11.6983 7.74138 11.3103 8.12931 11.3103 8.60345V21.6293C11.3103 22.1034 11.6983 22.4914 12.1724 22.4914C12.6466 22.4914 13.0345 22.1034 13.0345 21.6293V11.0948H15.8362V16.4138H15.1466C14.6724 16.4138 14.2845 16.8017 14.2845 17.2759V20.3879C14.2845 20.8621 14.6724 21.25 15.1466 21.25H18.2586C18.7328 21.25 19.1207 20.8621 19.1207 20.3879V17.2759C19.1207 16.8017 18.7328 16.4138 18.2586 16.4138H17.569V11.0948H21.5776V21.6293C21.5776 22.1034 21.9655 22.4914 22.4397 22.4914C22.9138 22.4914 23.3017 22.1034 23.3017 21.6293V8.61207C23.3017 8.13793 22.9138 7.75 22.4397 7.75ZM17.3966 18.1466V19.5345H16.0086V18.1466H17.3966ZM5.22414 17.6638V16.2759H6.61207V17.6638H5.22414ZM6.77586 20.7759V19.3879H8.16379V20.7759H6.77586ZM3.66379 20.7759V19.3879H5.05172V20.7759H3.66379Z",
    fill: "#6994BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2343_6943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3017,
    height: 19,
    fill: "white",
    transform: "translate(1 3.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminal);
export default __webpack_public_path__ + "static/media/terminal.c6ca63ff30528ebdfd034322d7e07a71.svg";
export { ForwardRef as ReactComponent };